export * from './dialogs/deposit.messages';
export * from './dialogs/withdrawal.messages';
export * from './dialogs/add-trading-account.messages';
export * from './dialogs/disable-accounts.messages';
export * from './dialogs/change-client-status.messages';
export * from './dialogs/change-trading-account-status.messages';
export * from './dialogs/add-user-to-client.messages';
export * from './dialogs/search-client.messages';
export * from './dialogs/assign-client-account-rights.messages';
export * from './dialogs/assign-supervised-rights.messages';
export * from './dialogs/add-fee.messages';
export * from './dialogs/add-bank-account.messages';
export * from './dialogs/add-edit-product-price.messages';
export * from './dialogs/fund-order.messages';

export * from './pages/error.messages';

export * from './pages/panel-accounts-edit.messages';
export * from './pages/panel-clients-add.messages';
export * from './pages/panel-clients-add-individual.messages';
export * from './pages/panel-clients-add-corporate.messages';
export * from './pages/panel-clients-edit.messages';
export * from './pages/panel-clients-edit-accounts.messages';
export * from './pages/client-entities.messages';
export * from './pages/client-users.messages';
export * from './pages/panel-settings-roles.messages';
export * from './pages/panel-settings-roles-add.messages';
export * from './pages/panel-settings-roles-edit.messages';
export * from './pages/panel-settings-audits.messages';
export * from './pages/panel-settings-operators-add.messages';
export * from './pages/panel-settings-operators-edit.messages';
export * from './pages/panel-settings-groups.messages';
export * from './pages/panel-settings-messaging.messages';
export * from './pages/panel-settings-groups-add.messages';
export * from './pages/panel-settings-groups-edit.messages';
export * from './pages/panel-settings-groups-edit-accounts.messages';
export * from './pages/panel-client-users-edit.messages';
export * from './pages/panel-accounts-use.messages';
export * from './pages/panel-accounts-add.messages';
export * from './pages/panel-accounts-add-cash.messages';
export * from './pages/panel-accounts-add-trading.messages';
export * from './pages/panel-settings-groups-edit-details.messages';
export * from './pages/panel-payments-edit.message';
export * from './pages/panel-reports-executions.messages';
export * from './pages/panel-reports-fx-executions.messages';
export * from './pages/panel-reports-accounts.messages';
export * from './pages/panel-reports-referred-accounts.messages';
export * from './pages/client-access-rights.messages';
export * from './pages/panel-settings-operators.messages';
export * from './pages/documents-report.messages';
export * from './pages/panel-accounts-edit-fee-plans.messages';
export * from './pages/panel-clients-edit-bank-accounts.messages';
export * from './pages/panel-bank-accounts.messages';
export * from './pages/panel-bank-accounts-edit.messages';
export * from './pages/panel-accounts-edit-details.messages';
export * from './pages/panel-accounts-edit-users.messages';
export * from './pages/panel-accounts-edit-current-positions.messages';
export * from './pages/panel-settings-file-import.messages';
export * from './pages/panel-accounts.messages';
export * from './pages/market-data-feeds-add.messages';
export * from './pages/feed-subscription-log.messages';
export * from './pages/platform-frontend-add.messages';
export * from './pages/exchange-add.messages';
export * from './pages/market-data-feed-subscription.messages';
export * from './pages/service-users.messages';
export * from './pages/panel-entitlement-reports.messages';
export * from './pages/market-data-usage-reports.messages';
export * from './pages/panel-settings-products/panel-settings-products.messages';
export * from './pages/panel-settings-products/panel-settings-products-edit-prices.messages';
export * from './pages/panel-settings-products/panel-settings-products-edit-details.messages';
export * from './pages/panel-orders.messages';
export * from './pages/panel-orders-edit.messages';
export * from './pages/panel-clients-edit-assessment.messages';
export * from './pages/panel-clients-edit-aml-source-of-funds.messages';
export * from './pages/panel-clients-edit-aml-estimated-worth.messages';
export * from './pages/panel-messages';
export * from './pages/operator-permission-filter.messages';
export * from './pages/market-data-feed-markup.messages';
export * from './pages/panel-plans';
export * from './pages/panel-order-routes.messages';
export * from './pages/panel-reports-campaigns.messages';


export * from './pages/panel-campaign-management.messages';
